export interface Awards {
  name: string;
  additionalInformation: string;
  key: string;
  link?
}

export const awards: Awards[] = [
  {
    name: 'PREDICTIVE ANALYSIS OF CARBON FOOTPRINT IN METROPOLITAN CITIES (MICROSOFT GRANT PROJECT)',
    additionalInformation:'The objective of this project is to identify the relationship between the increase in carbon footprint and deforestation in Indian metropolitan cities along with to predict the increase in carbon footprint over next few years and suggest optimal forest cover required for sustenance Published 2 papers regarding this project one in reputed journal of Springer'
     , key: 'az204',
     link:'https://www.researchgate.net/publication/343288832_Concept_for_Mapping_Carbon_footprint_with_Change_in_Vegetation_Cover_and_Population_in_India'

  },
  {
    name: 'React Django E commerce website',
    additionalInformation:
      'An Webshop to List different products along with cart functionality , and dummy stripe integration , along with reviews and rates of product',  key: 'az900',link:'https://github.com/munch-lax/Updated-ecommerce'
  },
  {
    name: 'Realtime chat app',
    additionalInformation:
      'A Simple chat forum to create channels for different topics, people can share messages and images along with search functionality according to messages and users',    key: 'dp900',
    link:'https://realtime-chat-forum.netlify.app/login'
  },
];
